import { useCallback, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft, Loader2, ShieldOff } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { EmptyState, PageHeader } from "@/components/common";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg, isManagerRole } from "@/lib/api";
import { LinksCard } from "@/components/boy/config/LinksCard";
import { PricingCard } from "@/components/boy/config/PricingCard";
import { PaymentCard } from "@/components/boy/config/PaymentCard";

export default function BoyConfig() {
  const { session } = useAuth();
  const mgr = isManagerRole(session.user);
  const [s, setS] = useState(null);
  const [params, setParams] = useSearchParams();
  const load = useCallback(() => api.get("/boy/settings").then((r) => setS(r.data)).catch((e) => toast.error(errMsg(e))), []);
  useEffect(() => {
    if (mgr) load();
  }, [mgr, load]);
  useEffect(() => {
    const mp = params.get("mp");
    if (!mp) return;
    if (mp === "ok") toast.success("Mercado Pago conectado ao Boy Express");
    else toast.error("Não foi possível conectar o Mercado Pago. Tente de novo.");
    setParams({}, { replace: true });
  }, [params, setParams]);
  if (!mgr) return <EmptyState icon={ShieldOff} title="Sem acesso" text="Só o Proprietário ou o Gerente alteram as configurações do Boy Express." />;
  return (
    <div className="space-y-6" data-testid="boy-config-page">
      <PageHeader eyebrow="Boy Express" title="Configurações do Boy Express" subtitle="Valores das corridas, links de cadastro e recebimento."
        actions={<Button asChild variant="outline"><Link to="/app/boy-express" data-testid="boy-back-rides-btn"><ArrowLeft className="mr-2 h-4 w-4" />Corridas</Link></Button>} />
      {!s ? <p className="flex justify-center py-10"><Loader2 className="h-6 w-6 animate-spin" /></p> : (
        <div className="grid grid-cols-1 gap-6 xl:grid-cols-2 [&>*]:min-w-0">
          <div className="space-y-6"><LinksCard code={s.code} /><PaymentCard s={s} onChange={load} /></div>
          <PricingCard config={s.config} onSaved={(config) => setS((x) => ({ ...x, config }))} />
        </div>
      )}
    </div>
  );
}
